import React from 'react'
import { Routes, Route } from 'react-router-dom'
import InventoryDashboard from './InventoryDashboard'
import InventoryItems from './InventoryItems'
import InventoryItemForm from './InventoryItemForm'
import InventoryItemDetail from './InventoryItemDetail'
import InventoryLocations from './InventoryLocations'
import InventoryMovements from './InventoryMovements'
import InventoryReports from './InventoryReports'
import POS from './POS'

const Inventory = () => {
  return (
    <Routes>
      <Route index element={<InventoryDashboard />} />
      <Route path="items" element={<InventoryItems />} />
      <Route path="items/new" element={<InventoryItemForm />} />
      <Route path="items/:id" element={<InventoryItemDetail />} />
      <Route path="items/:id/edit" element={<InventoryItemForm />} />
      <Route path="locations" element={<InventoryLocations />} />
      <Route path="movements" element={<InventoryMovements />} />
      <Route path="reports" element={<InventoryReports />} />
      <Route path="pos" element={<POS />} />
    </Routes>
  )
}

export default Inventory